document.querySelectorAll('form.form').forEach((form) => {
    if (form instanceof HTMLFormElement) {
        console.log('Adding submit listener to form', form);
        form.addEventListener('submit', (event) => {
            if (form.hasAttribute('data-submitting')) {
                event.preventDefault();
                return false;
            }
            form.setAttribute('data-submitting', '');
        });
    }
});

const midWifeForm = document.querySelector('#midWifeDealerForm');

if (midWifeForm) {
    const checkboxElMidWives = document.querySelector(
        '[name="--midWifeDealerForm[fromWhereKnowingFellhof][]"][value="midwives"]'
    );
    checkboxElMidWives.addEventListener('change', function () {
        document.getElementById('midWifeDealerForm-additionalInfoMidwives').required = checkboxElMidWives.checked;
    });

    const checkboxElBabywearingConsultant = document.querySelector(
        '[name="--midWifeDealerForm[fromWhereKnowingFellhof][]"][value="babywearingConsultant"]'
    );
    checkboxElBabywearingConsultant.addEventListener('change', function () {
        document.getElementById('midWifeDealerForm-additionalInfoBabywearingConsultant').required =
            checkboxElBabywearingConsultant.checked;
    });

    const checkboxElSonstiges = document.querySelector(
        '[name="--midWifeDealerForm[fromWhereKnowingFellhof][]"][value="sonstiges"]'
    );
    checkboxElSonstiges.addEventListener('change', function () {
        document.getElementById('midWifeDealerForm-additionalInfoSonstiges').required = checkboxElSonstiges.checked;
    });
}

const alpacaShopForm = document.querySelector('#alpacaShopForm');

if (alpacaShopForm) {
    const checkboxElSonstiges = document.querySelector(
        '[name="--alpacaShopForm[fromWhereKnowingFellhof][]"][value="sonstiges"]'
    );
    checkboxElSonstiges.addEventListener('change', function () {
        document.getElementById('alpacaShopForm-additionalInfoSonstiges').required = checkboxElSonstiges.checked;
    });
}


const inputMulticheckboxEls = document.querySelectorAll('.input--multicheckbox:has([data-required="true"])');
inputMulticheckboxEls.forEach((inputMulticheckboxEl) => {
    const checkboxInputEls = inputMulticheckboxEl.querySelectorAll('input[type="checkbox"]');
    const firstCheckboxInputEl = checkboxInputEls[0];
    if (firstCheckboxInputEl) {
        setMulticheckboxValidity(inputMulticheckboxEl, firstCheckboxInputEl);
        checkboxInputEls.forEach((checkboxInputEl) => {
            checkboxInputEl.addEventListener('change', function () {
                setMulticheckboxValidity(inputMulticheckboxEl, firstCheckboxInputEl);
            });
        });
    }
});

function setMulticheckboxValidity(inputMulticheckboxEl, firstCheckboxInputEl) {
    const multicheckboxValidationMessage = window.location.href.includes('/de/')
        ? 'Bitte mindestens eine Option auswählen.'
        : 'Please select at least one option.';

    firstCheckboxInputEl.setCustomValidity(
        [...inputMulticheckboxEl.querySelectorAll('input[type="checkbox"]')].some(
            (checkboxInputEl) => checkboxInputEl.checked
        )
            ? ''
            : multicheckboxValidationMessage
    );
}
